/**
 * 成员管理
 * @author limy
 */
import api from '@/services/api'
import {METHOD, request} from '@/utils/request'

export const dataApi = {
  async getDeptListWithDealer() {
    return request(api.comm.DEPT + "/listWithDealer", METHOD.GET);
  },
  async getFormDetail(keyId) {
    return request(api.comm.USER + "/" + keyId, METHOD.GET);
  },
  async saveFormDetail(result) {
    return request(api.comm.USER, METHOD.POST, result);
  },
  async saveFormAndInvite(result) {
    return request(api.comm.USER + '/saveAndInvite', METHOD.POST, result);
  },
  async getDeptList() {
    return request(api.comm.DEPT, METHOD.GET);
  },
  async syncDeptData() {
    return request(api.comm.DEPT + '/getDeptList', METHOD.GET);
  },
  async syncUserData() {
    return request(api.comm.USER + '/syncAllUserList', METHOD.GET);
  },
  async syncDeptUserData(deptId) {
    return request(api.comm.USER + '/syncOneDeptUserList?deptId=' + deptId, METHOD.GET);
  },
  /**
   * 设置经销商
   * @param deptId
   * @param dealerNo
   * @return {Promise<AxiosResponse<T>>}
   */
  async setDeptDealer(deptId, dealerNo) {
    return request(api.comm.DEPT + '/setDeptDealer?deptId=' + deptId + '&dealerNo=' + dealerNo, METHOD.GET);
  },
  /**
   * 设置大区
   * @param arr
   * @return {Promise<AxiosResponse<T>>}
   */
  async setDeptRegion(arr) {
    return request(api.comm.DEPT + '/setDeptRegion', METHOD.POST, arr);
  },
  async getRoleList() {
    return request(api.comm.ROLE + '/all', METHOD.GET);
  },
  async batchSaveRole(arr, roleId) {
    return request(api.comm.ROLE + '/batchSaveRole?roleId=' + roleId, METHOD.POST, arr);
  },
}


export default {dataApi}
